export default "/images/38b4ec115ae302419095d16886987bb4.avif";